'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FillEmptySpace = _react2['default'].createClass({
    displayName: 'FillEmptySpace',


    propTypes: {
        footerClass: _react2['default'].PropTypes.string //NOTE: If another React component is leveraging this component, include a unique key for each generated message. See MultiSelect for more info.
    },

    expandSpace: function expandSpace() {

        var footerClass = this.props.footerClass || '.m-footer';

        var thisNode = $(_reactDom2['default'].findDOMNode(this));
        var windowHeight = $(window).height();
        var componentYPos = thisNode.offset().top;
        var footerHeight = $(footerClass).outerHeight();
        var twitterHeight = $('.m-footer') && $('.m-twitter').outerHeight(); // this should probably be passed in as a prop for more flexibility like the line above
        var spaceToFill = windowHeight - componentYPos - footerHeight - twitterHeight - 5;
        thisNode.height(spaceToFill);
    },
    componentDidMount: function componentDidMount() {

        var self = this;
        this.expandSpace();
        if (window) {
            window.onresize = function () {
                self.expandSpace();
            };
        }
        $(document).bind('repositionFooter', function () {
            this.expandSpace();
        }.bind(this));
    },
    render: function render() {
        return _react2['default'].createElement('div', null);
    }
});
module.exports = FillEmptySpace;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/fill-empty-space.jsx
 ** module id = 706
 ** module chunks = 0
 **/